import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconVisibility = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconVisibility",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M480-320q75 0 128-52t52-128-52-127-128-53-127 53-53 127 53 128 127 52m0-72q-45 0-76-31t-32-77 32-76 76-32 77 32 31 76-31 77-77 31m0 192q-134 0-244-72T61-462q-5-9-7-18t-3-20 3-19 7-19q64-118 175-190t244-72 245 72 174 190q5 9 8 19t2 19l-2 20q-2 10-8 18-64 118-174 190t-245 72"
  })
}));